const SBABLogotype = ({ className }: { className?: string }) => {
  return (
    <svg
      aria-hidden='true'
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 227 72'
      fill='none'
    >
      <path
        fill='#707070'
        fillRule='evenodd'
        d='m226.771 3.448-9.552 45.002-11.686-2.488L215.087 1l11.684 2.448Zm-2.762 60.437c0 4.422-3.554 7.698-7.856 7.698s-7.816-3.276-7.816-7.698c0-4.422 3.474-7.738 7.816-7.738s7.856 3.316 7.856 7.738Z'
        clipRule='evenodd'
      />
      <path
        fill='#000'
        fillOpacity='.9'
        fillRule='evenodd'
        d='M45.042 49.951c0 10.618-8.092 17.21-21.594 17.21C9.712 67.161.434 59.977 0 48.213h10.5c.396 6.316 5.726 10.066 12.948 10.066 6.12 0 11.054-2.448 11.054-7.578 0-3.988-3.396-6.672-12.632-9.08l-5.448-1.422c-9.79-2.566-14.684-8.33-14.684-16.184 0-10.502 9.196-16.816 20.842-16.816 12.198 0 20.804 6.828 20.922 17.368h-10.5c-.276-5.25-4.026-8.488-10.422-8.488-5.842 0-10.342 2.606-10.342 7.5 0 3.79 2.488 6.514 10.502 8.646l5.408 1.462c11.13 3 16.894 8.408 16.894 16.264Zm29.86 7.223h-13.5V40.91h13.5c7.027 0 10.54 3.08 10.54 8.054s-3.513 8.21-10.54 8.21Zm-13.5-39.988h11.721c6.238 0 9.634 2.368 9.634 7.342s-3.396 7.58-9.634 7.58H61.401V17.186Zm21.235 19.46v-1.342c6.83-1.618 10.108-6.196 10.108-12.276 0-8.29-5.884-14.724-20.528-14.724H51.02v57.752h23.21c15.554 0 21.2-7.066 21.2-15.672 0-7.42-4.304-12.158-12.792-13.738Zm39.438-15.04-7.484 21.278h16.57l-7.388-21.278h-1.698Zm28.502 44.45h-11.368l-5.128-14.764h-22.448l-5.19 14.764H95.627l21.04-57.752h13.028l20.882 57.752Zm13.627-8.882h13.5c7.028 0 10.54-3.236 10.54-8.21s-3.512-8.054-10.54-8.054h-13.5v16.264Zm11.722-39.988h-11.722v14.922h11.722c6.238 0 9.634-2.606 9.634-7.58s-3.396-7.342-9.634-7.342Zm9.752 18.118v1.342c8.486 1.58 12.79 6.318 12.79 13.738 0 8.606-5.644 15.672-21.198 15.672h-23.212V8.304h21.198c14.646 0 20.528 6.434 20.528 14.724 0 6.08-3.278 10.658-10.106 12.276Z'
        clipRule='evenodd'
      />
    </svg>
  );
};
export default SBABLogotype;
